import dayjs from "dayjs";
import { replaceUnderScoreAddSpace } from "../utils/utils";

export const TIME_ZONE_LIST = [
  { value: "PST", label: "Pacific Standard Time (UTC -8)" },
  { value: "EST", label: "Eastern Standard Time (UTC -5)" },
  { value: "CST", label: "Central Standard Time (UTC -6)" },
  { value: "MST", label: "Mountain Standard Time (UTC -7)" },
  { value: "AST", label: "Atlantic Standard Time (UTC -4)" },
  { value: "HST", label: "Hawaii Standard Time (UTC -10)" },
  { value: "EDT", label: "Eastern Daylight Time (UTC -4)" },
  { value: "PDT", label: "Pacific Daylight Time (UTC -7)" },
  { value: "CDT", label: "Central Daylight Time (UTC -5)" },
  { value: "ADT", label: "Atlantic Daylight Time (UTC -3)" },
  { value: "MDT", label: "Mountain Daylight Time (UTC -6)" },
  { value: "IST", label: "Indian Standard Time (UTC +5:30)" },
  { value: "AKDT", label: "Alaska Daylight Time (UTC -8)" },
  { value: "AKST", label: "Alaska Standard Time (UTC -9)" },
];

export const TIME_ZONE_MAPPER = TIME_ZONE_LIST.reduce((obj, item) => {
  obj[item.value] = replaceUnderScoreAddSpace(item?.value) + ` (${item.label})`;
  return obj;
}, {} as Record<string, string>);

export const STATE_LIST = [
  { value: "1", label: "Alabama (AL)" },
  { value: "2", label: "Alaska (AK)" },
  { value: "3", label: "Arizona (AZ)" },
  { value: "4", label: "Arkansas (AR)" },
  { value: "5", label: "California (CA)" },
  { value: "6", label: "Colorado (CO)" },
  { value: "7", label: "Connecticut (CT)" },
  { value: "8", label: "Delaware (DE)" },
  { value: "9", label: "Florida (FL)" },
  { value: "10", label: "Georgia (GA)" },
  { value: "11", label: "Hawaii (HI)" },
  { value: "12", label: "Idaho (ID)" },
  { value: "13", label: "Illinois (IL)" },
  { value: "14", label: "Indiana (IN)" },
  { value: "15", label: "Iowa (IA)" },
  { value: "16", label: "Kansas (KS)" },
  { value: "17", label: "Kentucky (KY)" },
  { value: "18", label: "Louisiana (LA)" },
  { value: "19", label: "Maine (ME)" },
  { value: "20", label: "Maryland (MD)" },
  { value: "21", label: "Massachusetts (MA)" },
  { value: "22", label: "Michigan (MI)" },
  { value: "23", label: "Minnesota (MN)" },
  { value: "24", label: "Mississippi (MS)" },
  { value: "25", label: "Missouri (MO)" },
  { value: "26", label: "Montana (MT)" },
  { value: "27", label: "Nebraska (NE)" },
  { value: "28", label: "Nevada (NV)" },
  { value: "29", label: "New Hampshire (NH)" },
  { value: "30", label: "New Jersey (NJ)" },
  { value: "31", label: "New Mexico (NM)" },
  { value: "32", label: "New York (NY)" },
  { value: "33", label: "North Carolina (NC)" },
  { value: "34", label: "North Dakota (ND)" },
  { value: "35", label: "Ohio (OH)" },
  { value: "36", label: "Oklahoma (OK)" },
  { value: "37", label: "Oregon (OR)" },
  { value: "38", label: "Pennsylvania (PA)" },
  { value: "39", label: "Rhode Island (RI)" },
  { value: "40", label: "South Carolina (SC)" },
  { value: "41", label: "South Dakota (SD)" },
  { value: "42", label: "Tennessee (TN)" },
  { value: "43", label: "Texas (TX)" },
  { value: "44", label: "Utah (UT)" },
  { value: "45", label: "Vermont (VT)" },
  { value: "46", label: "Virginia (VA)" },
  { value: "47", label: "Washington (WA)" },
  { value: "48", label: "West Virginia (WV)" },
  { value: "49", label: "Wisconsin (WI)" },
  { value: "50", label: "Wyoming (WY)" },
];

const STATE_LIST_WITHOUT_SHORT = [
  { value: "1", label: "Alabama" },
  { value: "2", label: "Alaska" },
  { value: "3", label: "Arizona" },
  { value: "4", label: "Arkansas" },
  { value: "5", label: "California" },
  { value: "6", label: "Colorado" },
  { value: "7", label: "Connecticut" },
  { value: "8", label: "Delaware" },
  { value: "9", label: "Florida" },
  { value: "10", label: "Georgia" },
  { value: "11", label: "Hawaii" },
  { value: "12", label: "Idaho" },
  { value: "13", label: "Illinois" },
  { value: "14", label: "Indiana" },
  { value: "15", label: "Iowa" },
  { value: "16", label: "Kansas" },
  { value: "17", label: "Kentucky" },
  { value: "18", label: "Louisiana" },
  { value: "19", label: "Maine" },
  { value: "20", label: "Maryland" },
  { value: "21", label: "Massachusetts" },
  { value: "22", label: "Michigan" },
  { value: "23", label: "Minnesota" },
  { value: "24", label: "Mississippi" },
  { value: "25", label: "Missouri" },
  { value: "26", label: "Montana" },
  { value: "27", label: "Nebraska" },
  { value: "28", label: "Nevada" },
  { value: "29", label: "New Hampshire" },
  { value: "30", label: "New Jersey" },
  { value: "31", label: "New Mexico" },
  { value: "32", label: "New York" },
  { value: "33", label: "North Carolina" },
  { value: "34", label: "North Dakota" },
  { value: "35", label: "Ohio" },
  { value: "36", label: "Oklahoma" },
  { value: "37", label: "Oregon" },
  { value: "38", label: "Pennsylvania" },
  { value: "39", label: "Rhode Island" },
  { value: "40", label: "South Carolina" },
  { value: "41", label: "South Dakota" },
  { value: "42", label: "Tennessee" },
  { value: "43", label: "Texas" },
  { value: "44", label: "Utah" },
  { value: "45", label: "Vermont" },
  { value: "46", label: "Virginia" },
  { value: "47", label: "Washington" },
  { value: "48", label: "West Virginia" },
  { value: "49", label: "Wisconsin" },
  { value: "50", label: "Wyoming" },
];

export const STATE_RECORD_FULL_NAME_MAPPER = STATE_LIST.reduce((obj, item) => {
  obj[item.value] = item.label;
  return obj;
}, {} as Record<string, string>);

export const STATE_RECORD_FULL_NAME_MAPPER_WITHOUT_SHORT =
  STATE_LIST_WITHOUT_SHORT.reduce((obj, item) => {
    obj[item.value] = item.label;
    return obj;
  }, {} as Record<string, string>);

export const STATE_RECORD = {
  "1": "AL",
  "2": "AK",
  "3": "AZ",
  "4": "AR",
  "5": "CA",
  "6": "CO",
  "7": "CT",
  "8": "DE",
  "9": "FL",
  "10": "GA",
  "11": "HI",
  "12": "ID",
  "13": "IL",
  "14": "IN",
  "15": "IA",
  "16": "KS",
  "17": "KY",
  "18": "LA",
  "19": "ME",
  "20": "MD",
  "21": "MA",
  "22": "MI",
  "23": "MN",
  "24": "MS",
  "25": "MO",
  "26": "MT",
  "27": "NE",
  "28": "NV",
  "29": "NH",
  "30": "NJ",
  "31": "NM",
  "32": "NY",
  "33": "NC",
  "34": "ND",
  "35": "OH",
  "36": "OK",
  "37": "OR",
  "38": "PA",
  "39": "RI",
  "40": "SC",
  "41": "SD",
  "42": "TN",
  "43": "TX",
  "44": "UT",
  "45": "VT",
  "46": "VA",
  "47": "WA",
  "48": "WV",
  "49": "WI",
  "50": "WY",
} as Record<string, string>;

export const SHORT_GENDER_NAME_MAPPER = {
  MALE: "M",
  FEMALE: "F",
  OTHER: "O",
} as Record<string, string>;

export const GENDER_RECORD = {
  MALE: "Male",
  FEMALE: "Female",
  OTHER: "Other",
} as Record<string, string>;

export const COUNTRIES_LIST = [
  { value: "United States", label: "United States" },
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Albania", label: "Albania" },
  { value: "Algeria", label: "Algeria" },
  { value: "Andorra", label: "Andorra" },
  { value: "Angola", label: "Angola" },
  { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
  { value: "Argentina", label: "Argentina" },
  { value: "Armenia", label: "Armenia" },
  { value: "Australia", label: "Australia" },
  { value: "Austria", label: "Austria" },
  { value: "Azerbaijan", label: "Azerbaijan" },
  { value: "Bahamas", label: "Bahamas" },
  { value: "Bahrain", label: "Bahrain" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Barbados", label: "Barbados" },
  { value: "Belarus", label: "Belarus" },
  { value: "Belgium", label: "Belgium" },
  { value: "Belize", label: "Belize" },
  { value: "Benin", label: "Benin" },
  { value: "Bhutan", label: "Bhutan" },
  { value: "Bolivia", label: "Bolivia" },
  { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
  { value: "Botswana", label: "Botswana" },
  { value: "Brazil", label: "Brazil" },
  { value: "Brunei", label: "Brunei" },
  { value: "Bulgaria", label: "Bulgaria" },
  { value: "Burkina Faso", label: "Burkina Faso" },
  { value: "Burundi", label: "Burundi" },
  { value: "Cabo Verde", label: "Cabo Verde" },
  { value: "Cambodia", label: "Cambodia" },
  { value: "Cameroon", label: "Cameroon" },
  { value: "Canada", label: "Canada" },
  { value: "Central African Republic", label: "Central African Republic" },
  { value: "Chad", label: "Chad" },
  { value: "Chile", label: "Chile" },
  { value: "China", label: "China" },
  { value: "Colombia", label: "Colombia" },
  { value: "Comoros", label: "Comoros" },
  {
    value: "Congo (Congo-Brazzaville)",
    label: "Congo (Congo-Brazzaville)",
  },
  { value: "Congo, Republic of the", label: "Congo, Republic of the" },
  { value: "Costa Rica", label: "Costa Rica" },
  { value: "Croatia", label: "Croatia" },
  { value: "Cuba", label: "Cuba" },
  { value: "Cyprus", label: "Cyprus" },
  { value: "Czechia (Czech Republic)", label: "Czechia (Czech Republic)" },
  { value: "Denmark", label: "Denmark" },
  { value: "Djibouti", label: "Djibouti" },
  { value: "Dominica", label: "Dominica" },
  { value: "Dominican Republic", label: "Dominican Republic" },
  { value: "Ecuador", label: "Ecuador" },
  { value: "Egypt", label: "Egypt" },
  { value: "El Salvador", label: "El Salvador" },
  { value: "Equatorial Guinea", label: "Equatorial Guinea" },
  { value: "Eritrea", label: "Eritrea" },
  { value: "Estonia", label: "Estonia" },
  { value: "Eswatini", label: "Eswatini" },
  { value: "Ethiopia", label: "Ethiopia" },
  { value: "Fiji", label: "Fiji" },
  { value: "Finland", label: "Finland" },
  { value: "France", label: "France" },
  { value: "Gabon", label: "Gabon" },
  { value: "Gambia", label: "Gambia" },
  { value: "Georgia", label: "Georgia" },
  { value: "Germany", label: "Germany" },
  { value: "Ghana", label: "Ghana" },
  { value: "Greece", label: "Greece" },
  { value: "Grenada", label: "Grenada" },
  { value: "Guatemala", label: "Guatemala" },
  { value: "Guinea", label: "Guinea" },
  { value: "Guinea-Bissau", label: "Guinea-Bissau" },
  { value: "Guyana", label: "Guyana" },
  { value: "Haiti", label: "Haiti" },
  { value: "Honduras", label: "Honduras" },
  { value: "Hungary", label: "Hungary" },
  { value: "Iceland", label: "Iceland" },
  { value: "India", label: "India" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Iran", label: "Iran" },
  { value: "Iraq", label: "Iraq" },
  { value: "Ireland", label: "Ireland" },
  { value: "Israel", label: "Israel" },
  { value: "Italy", label: "Italy" },
  { value: "Jamaica", label: "Jamaica" },
  { value: "Japan", label: "Japan" },
  { value: "Jordan", label: "Jordan" },
  { value: "Kazakhstan", label: "Kazakhstan" },
  { value: "Kenya", label: "Kenya" },
  { value: "Kiribati", label: "Kiribati" },
  { value: "Korea, North", label: "Korea, North" },
  { value: "Korea, South", label: "Korea, South" },
  { value: "Kuwait", label: "Kuwait" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan" },
  { value: "Laos", label: "Laos" },
  { value: "Latvia", label: "Latvia" },
  { value: "Lebanon", label: "Lebanon" },
  { value: "Lesotho", label: "Lesotho" },
  { value: "Liberia", label: "Liberia" },
  { value: "Libya", label: "Libya" },
  { value: "Liechtenstein", label: "Liechtenstein" },
  { value: "Lithuania", label: "Lithuania" },
  { value: "Luxembourg", label: "Luxembourg" },
  { value: "Madagascar", label: "Madagascar" },
  { value: "Malawi", label: "Malawi" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Maldives", label: "Maldives" },
  { value: "Mali", label: "Mali" },
  { value: "Malta", label: "Malta" },
  { value: "Marshall Islands", label: "Marshall Islands" },
  { value: "Mauritania", label: "Mauritania" },
  { value: "Mauritius", label: "Mauritius" },
  { value: "Mexico", label: "Mexico" },
  { value: "Micronesia", label: "Micronesia" },
  { value: "Moldova", label: "Moldova" },
  { value: "Monaco", label: "Monaco" },
  { value: "Mongolia", label: "Mongolia" },
  { value: "Montenegro", label: "Montenegro" },
  { value: "Morocco", label: "Morocco" },
  { value: "Mozambique", label: "Mozambique" },
  { value: "Myanmar", label: "Myanmar" },
  { value: "Namibia", label: "Namibia" },
  { value: "Nauru", label: "Nauru" },
  { value: "Nepal", label: "Nepal" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Nicaragua", label: "Nicaragua" },
  { value: "Niger", label: "Niger" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "North Macedonia", label: "North Macedonia" },
  { value: "Norway", label: "Norway" },
  { value: "Oman", label: "Oman" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Palau", label: "Palau" },
  { value: "Panama", label: "Panama" },
  { value: "Papua New Guinea", label: "Papua New Guinea" },
  { value: "Paraguay", label: "Paraguay" },
  { value: "Peru", label: "Peru" },
  { value: "Philippines", label: "Philippines" },
  { value: "Poland", label: "Poland" },
  { value: "Portugal", label: "Portugal" },
  { value: "Qatar", label: "Qatar" },
  { value: "Romania", label: "Romania" },
  { value: "Russia", label: "Russia" },
  { value: "Rwanda", label: "Rwanda" },
  { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
  { value: "Saint Lucia", label: "Saint Lucia" },
  {
    value: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  { value: "Samoa", label: "Samoa" },
  { value: "San Marino", label: "San Marino" },
  { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "Senegal", label: "Senegal" },
  { value: "Serbia", label: "Serbia" },
  { value: "Seychelles", label: "Seychelles" },
  { value: "Sierra Leone", label: "Sierra Leone" },
  { value: "Singapore", label: "Singapore" },
  { value: "Slovakia", label: "Slovakia" },
  { value: "Slovenia", label: "Slovenia" },
  { value: "Solomon Islands", label: "Solomon Islands" },
  { value: "Somalia", label: "Somalia" },
  { value: "South Africa", label: "South Africa" },
  { value: "South Sudan", label: "South Sudan" },
  { value: "Spain", label: "Spain" },
  { value: "Sri Lanka", label: "Sri Lanka" },
  { value: "Sudan", label: "Sudan" },
  { value: "Suriname", label: "Suriname" },
  { value: "Sweden", label: "Sweden" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Syria", label: "Syria" },
  { value: "Taiwan", label: "Taiwan" },
  { value: "Tajikistan", label: "Tajikistan" },
  { value: "Tanzania", label: "Tanzania" },
  { value: "Thailand", label: "Thailand" },
  { value: "Timor-Leste", label: "Timor-Leste" },
  { value: "Togo", label: "Togo" },
  { value: "Tonga", label: "Tonga" },
  { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
  { value: "Tunisia", label: "Tunisia" },
  { value: "Turkey", label: "Turkey" },
  { value: "Turkmenistan", label: "Turkmenistan" },
  { value: "Tuvalu", label: "Tuvalu" },
  { value: "Uganda", label: "Uganda" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "Uruguay", label: "Uruguay" },
  { value: "Uzbekistan", label: "Uzbekistan" },
  { value: "Vanuatu", label: "Vanuatu" },
  { value: "Vatican City", label: "Vatican City" },
  { value: "Venezuela", label: "Venezuela" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Yemen", label: "Yemen" },
  { value: "Zambia", label: "Zambia" },
  { value: "Zimbabwe", label: "Zimbabwe" },
];





export const TIME_ZONE_WITH_OFFSET_LIST = [
  {
    curType: "PST",
    value: "America/Los_Angeles",
    label: "Pacific Standard Time (GMT -08:00)",
  },
  {
    curType: "EST",
    value: "America/New_York",
    label: "Eastern Standard Time (GMT -05:00)",
  },
  {
    curType: "CST",
    value: "America/Chicago",
    label: "Central Standard Time (GMT -06:00)",
  },
  {
    curType: "MST",
    value: "America/Denver",
    label: "Mountain Standard Time (GMT -07:00)",
  },
  {
    curType: "AST",
    value: "America/Halifax",
    label: "Atlantic Standard Time (GMT -04:00)",
  },
  {
    curType: "HST",
    value: "Pacific/Honolulu",
    label: "Hawaii Standard Time (GMT -10:00)",
  },
  {
    curType: "EDT",
    value: "America/Toronto",
    label: "Eastern Daylight Time (GMT -04:00)",
  },
  {
    curType: "PDT",
    value: "America/Los_Angeles",
    label: "Pacific Daylight Time (GMT -07:00)",
  },
  {
    curType: "CDT",
    value: "America/Chicago",
    label: "Central Daylight Time (GMT -05:00)",
  },
  {
    curType: "ADT",
    value: "America/Halifax",
    label: "Atlantic Daylight Time (GMT -03:00)",
  },
  {
    curType: "MDT",
    value: "America/Denver",
    label: "Mountain Daylight Time (GMT -06:00)",
  },
  {
    curType: "IST",
    value: "Asia/Kolkata",
    label: "Indian Standard Time (GMT +05:30)",
  },
  {
    curType: "AKDT",
    value: "America/Anchorage",
    label: "Alaska Daylight Time (GMT -08:00)",
  },
  {
    curType: "AKST",
    value: "America/Anchorage",
    label: "Alaska Standard Time (GMT -09:00)",
  },
];

export const PREFERENCE_TYPE = [
  { value: "LAB", label: "Lab" },
  { value: "PHARMACY", label: "Pharmacy" },
  { value: "RADIOLOGY", label: "Radiology" },
];

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertToUTC = (dateString: string, timeZone: string): string => {
  const date = dayjs(dateString).tz(timeZone, true);
  const utcDate = date.utc();
  return utcDate.toISOString();
};
export const PREFERENCES_TYPE_MAPPER = {
  RADIOLOGY: "Radiology Name",
  PHARMACY: "Pharmacy Name",
  LAB: "Lab Name",
} as Record<string, string>;

export const STATE_STRING_LIST = [
  { value: "Alabama (AL)", label: "Alabama (AL)" },
  { value: "Alaska (AK)", label: "Alaska (AK)" },
  { value: "Arizona (AZ)", label: "Arizona (AZ)" },
  { value: "Arkansas (AR)", label: "Arkansas (AR)" },
  { value: "California (CA)", label: "California (CA)" },
  { value: "Colorado (CO)", label: "Colorado (CO)" },
  { value: "Connecticut (CT)", label: "Connecticut (CT)" },
  { value: "Delaware (DE)", label: "Delaware (DE)" },
  { value: "Florida (FL)", label: "Florida (FL)" },
  { value: "Georgia (GA)", label: "Georgia (GA)" },
  { value: "Hawaii (HI)", label: "Hawaii (HI)" },
  { value: "Idaho (ID)", label: "Idaho (ID)" },
  { value: "Illinois (IL)", label: "Illinois (IL)" },
  { value: "Indiana (IN)", label: "Indiana (IN)" },
  { value: "Iowa (IA)", label: "Iowa (IA)" },
  { value: "Kansas (KS)", label: "Kansas (KS)" },
  { value: "Kentucky (KY)", label: "Kentucky (KY)" },
  { value: "Louisiana (LA)", label: "Louisiana (LA)" },
  { value: "Maine (ME)", label: "Maine (ME)" },
  { value: "Maryland (MD)", label: "Maryland (MD)" },
  { value: "Massachusetts (MA)", label: "Massachusetts (MA)" },
  { value: "Michigan (MI)", label: "Michigan (MI)" },
  { value: "Minnesota (MN)", label: "Minnesota (MN)" },
  { value: "Mississippi (MS)", label: "Mississippi (MS)" },
  { value: "Missouri (MO)", label: "Missouri (MO)" },
  { value: "Montana (MT)", label: "Montana (MT)" },
  { value: "Nebraska (NE)", label: "Nebraska (NE)" },
  { value: "Nevada (NV)", label: "Nevada (NV)" },
  { value: "New Hampshire (NH)", label: "New Hampshire (NH)" },
  { value: "New Jersey (NJ)", label: "New Jersey (NJ)" },
  { value: "New Mexico (NM)", label: "New Mexico (NM)" },
  { value: "New York (NY)", label: "New York (NY)" },
  { value: "North Carolina (NC)", label: "North Carolina (NC)" },
  { value: "North Dakota (ND)", label: "North Dakota (ND)" },
  { value: "Ohio (OH)", label: "Ohio (OH)" },
  { value: "Oklahoma (OK)", label: "Oklahoma (OK)" },
  { value: "Oregon (OR)", label: "Oregon (OR)" },
  { value: "Pennsylvania (PA)", label: "Pennsylvania (PA)" },
  { value: "Rhode Island (RI)", label: "Rhode Island (RI)" },
  { value: "South Carolina (SC)", label: "South Carolina (SC)" },
  { value: "South Dakota (SD)", label: "South Dakota (SD)" },
  { value: "Tennessee (TN)", label: "Tennessee (TN)" },
  { value: "Texas (TX)", label: "Texas (TX)" },
  { value: "Utah (UT)", label: "Utah (UT)" },
  { value: "Vermont (VT)", label: "Vermont (VT)" },
  { value: "Virginia (VA)", label: "Virginia (VA)" },
  { value: "Washington (WA)", label: "Washington (WA)" },
  { value: "West Virginia (WV)", label: "West Virginia (WV)" },
  { value: "Wisconsin (WI)", label: "Wisconsin (WI)" },
  { value: "Wyoming (WY)", label: "Wyoming (WY)" },
];
